<template>
  <div class="main">
    <c-panel>
      <form-receita :paramId="$route.params.id" v-on:onSubmitReceita="onSubmitReceita"></form-receita>
    </c-panel>
  </div>
</template>
<script>
import formReceita from "./form"

export default {
  methods: {
    onSubmitReceita () {
      this.$router.push('/admin/merenda/receita')
    }
  },
  components: { formReceita }
}
</script>

